<template>
  <reference-layout class="functions">
    <template #header>
      <reference-header header-title="Функции">
        <template #header-actions>
          <div class="layout-header-action">
            <c-button-1
              class="functions__add-new"
              label="Новая функция"
              :icon="{
              icon: 'plus',
              color: 'blue',
              }"
              color="white"
              @click="$router.push({ name: 'function-information' })"
            />
          </div>
        </template>
      </reference-header>
    </template>

    <template #subheader>
      <div class="functions__filters">
        <div class="row">
          <div class="col col-xl-5 col-md-6 col-12">
            <c-select
              v-model="filtersForm.post"
              type="select"
              label="Должность"
              :multiple="true"
              :searchable="true"
              :placeholder="'Все'"
              :items="collections.post"
              :checkbox="true"
              :checkbox-value="filtersForm.postReverse"
              :checkbox-type="'icon'"
              :checkbox-tooltip="{
                disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
                activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
                notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
              }"
              :useCustomColors="true"
              @checkboxChange="filtersForm.postReverse = $event"
            />
          </div>
          <div class="col col-xl-4 col-md-6 col-12">
            <c-select
              v-model="filtersForm.filial"
              type="select"
              label="Филиал"
              :multiple="true"
              :searchable="true"
              :placeholder="'Все'"
              :items="collections.filials"
              :checkbox="true"
              :checkbox-value="filtersForm.filialReverse"
              :checkbox-type="'icon'"
              :checkbox-tooltip="{
                disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
                activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
                notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
              }"
              :useCustomColors="true"
              @checkboxChange="filtersForm.filialReverse = $event"
            />
          </div>
          <div class="col col-xl-3 col-md-6 col-12">
            <c-select
              v-model="filtersForm.status"
              type="select"
              label="Статус"
              :multiple="true"
              :searchable="true"
              :placeholder="'Все'"
              :items="collections.status"
              :checkbox="true"
              :checkbox-value="filtersForm.statusReverse"
              :checkbox-type="'icon'"
              :checkbox-tooltip="{
                disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
                activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
                notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
              }"
              :useCustomColors="true"
              @checkboxChange="filtersForm.statusReverse = $event"
            />
          </div>
          <div class="col col-xl-5 col-md-6 col-12">
            <c-input
              v-model="filtersForm.name"
              type="text"
              label="Наименование"
              placeholder="Любое"
              :clearable="true"
            />
          </div>
          <div class="col col-12 col-md-12 col-xl-7">
            <div class="functions__filters-actions">
              <c-button
                class="functions__filters-action"
                label="Сбросить"
                size="large"
                @click="resetFilters"
              />
              <c-button
                class="functions__filters-action"
                label="Применить"
                color="primary"
                @click="applyFilters"
              />
            </div>
          </div>
        </div>
      </div>
      
      <div class="functions__table-actions">
        <c-button-1
          class="functions__table-action"
          responsive
          :disabled="isLoadingData || tableData.activeFilteredColumns.length === 0"
          label="Сбросить фильтры столбцов"
          :icon="{ color: 'pink', icon: 'filter-drop' }"
          type="with-icon"
          @click="resetColumnFilters"
        />

        <c-button-1
          class="functions__table-action"
          responsive
          label="Настроить столбцы"
          icon="cog"
          type="with-icon"
          @click="openColumnSettingsModal"
        />

        <m-table-settings
          ref="columnSettings"
          :columns="tableData.defaultColumns"
          :disabled-columns="tableData.disabledColumns"
          :default-disabled-columns="tableData.defaultDisabledColumns"
          @apply="submitTableSettings"
        />
      </div>
    </template>

    <template #list>
      <c-data-table
        v-if="!isLoadingData || tableData.page > 1"
        ref="accountHistory"
        class="functions__table"
        :levels="1"
        :sorted-column="tableData.sortedColumn"
        :disabled-columns="tableData.disabledColumns"
        :filtered-columns="tableData.filteredColumns"
        :active-filtered-columns="tableData.activeFilteredColumns"
        :data="tableData"
        :reference-list="tableData.referenceFilterList"
        :empty-records-label="'Записи не найдены'"
        :operations-status="'active'"
        @sortedEvent="onTableSort"
        @getReferenceValues="setColumnReferenceFilterList"
        @reset-column-filters="tableData.activeFilteredColumns = []"
        @remove-column-filter="onColumnFilterRemove"
        @set-column-filter="onSetColumnFilter"
        @set-column-filter-by-index="onSetColumnFilterByIndex"
        @disable-column-sorted-flag="onDisableColumnSortedFlag"
        @change-sorting-column="onSortingColumnChange"
        @remove="removeCalculationSheet"
        @editRecord="editRecord"
      />

      <c-loader
        v-if="isLoadingData"
        label="Данные загружаются"
        :active="isLoadingData"
        :height="'200'"
      />
    </template>

    <transition name="fade">
      <display-shown-items-count
        v-if="!isLoadingData"
        :total-items-count="totalItemsCount"
        :shown-items-count="tableData.records.length"
      />
    </transition>
  </reference-layout>
</template>

<script>
import { mapState } from "vuex";
import ReferenceLayout from "@/layouts/reference-layout";
import ReferenceHeader from "@/components/reference-components/reference-header";
import Button from "@/components/controls2/Button";
import Button1 from "@/components/controls/button";
import Select from "@/components/controls2/Select";
import Input from "@/components/controls2/Input";
import GoogleForm from "@/pages/calculation-sheets/components/google/index";
import { onScrollEnd } from "@/helpers/events";
import Loader from "@/components/loader";
import TopButton from "@/components/top-button";
import { Function } from "@/entities/models/function";
import DataTable from "@/pages/personal-employee/finance/components/data-table";
import TableSettingsModal from "@/components/modals/table-columns/modal/";
import DisplayShownItemsCount from "@/components/display-shown-items-count";

export default {
  name: "functions",
  components: {
    ReferenceLayout,
    ReferenceHeader,
    GoogleForm,
    TopButton,
    DisplayShownItemsCount,
    "c-button": Button,
    "c-button-1": Button1,
    "c-input": Input,
    "c-select": Select,
    "c-loader": Loader,
    "c-data-table": DataTable,
    "m-table-settings": TableSettingsModal,
  },
  data() {
    return {
      isLoadingData: false,
      googleFormIsSubmitted: false,
      isMoreDataAvailable: true,
      isFirstInit: true,

      sp: {},

      filtersForm: {
        post: "",
        postReverse: false,
        filial: "",
        filialReverse: false,
        status: "",
        statusReverse: false,
        name: ""
      },

      collections: {
        filials: [],
        status: [],
        post: [],
      },

      statusesIcons: [
        {
          id: 1,
          value: 
          `
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 2V8.5M10.4253 3.07318C11.9816 4.15718 13 5.95965 13 8C13 11.3137 10.3137 14 7 14C3.68629 14 1 11.3137 1 8C1 5.95965 2.01843 4.15718 3.57468 3.07318" stroke="#0066FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `
        },
        {
          id: 2,
          value: 
          `
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 4.5V7.5L9 8.5M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z" stroke="#FFB800" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `
        },
        {
          id: 3,
          value: 
          `
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 6.5L7 8.5C7 8.5 10.3284 5.17157 11.5 4M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z" stroke="#12C971" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `
        },
        {
          id: 4,
          value: 
          `
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 7.5H9M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `
        },
        {
          id: 5,
          value: 
          `
          <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 5.5L9 9.5M9 5.5L5 9.5M13 7.5C13 10.8137 10.3137 13.5 7 13.5C3.68629 13.5 1 10.8137 1 7.5C1 4.18629 3.68629 1.5 7 1.5C10.3137 1.5 13 4.18629 13 7.5Z" stroke="#FF238D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          `
        },
      ],

      tableData: {
        columns: [],
        defaultColumns: [],
        columnsSequence: ["status", "name", "executive", "filials", "responsible", "labor_costs", "tools", "indicators", "comments"],
        actions: true,
        type: "functions",
        records: [],
        sortedColumn: {
          sortBy: "date_created",
          sortType: "desc",
        },
        defaultDisabledColumns: [],
        filteredColumns: [],
        disabledColumns: [],
        settingsModal: false,
        activeFilteredColumns: [],
        filters: [],
        globalFilters: [],
        activeFilteredColumnsQueryLocal: null,
        globalFiltersQueryLocal: null,
        page: 1,
        referenceFilterList: [],
      },
    }
  },
  computed: {
    ...mapState({
      tableColumns: (state) => state.functions.tableColumns,
      userTableColumns: (state) => state.functions.userTableColumns,
      totalItemsCount: (state) => state.functions.totalItemsCount,
      totalPages: (state) => state.functions.totalPages,
      filials: (state) => state.calculationSheets.filials,
    }),
    order() {
      const { sortBy, sortType } = this.tableData.sortedColumn;
      if (sortType !== "desc") return sortBy;
      return `-${sortBy}`;
    },
  },

  watch: {
    filials: {
      handler() {
        this.collections.filials = this.filials.map(filial => ({
          value: filial.id,
          label: filial.name
        }))
      },
      deep: true,
    },
    tableColumns: {
      handler() {
        this.tableData.columns = [];
        this.tableData.defaultColumns = [];
        this.tableData.filteredColumns = [];

        this.tableData.columnsSequence.forEach(columnId => {
          this.tableColumns.forEach(column => {
            if (columnId === column.code) {
              this.tableData.columns.push({
                id: column.code,
                label: column.name,
                fullName: column.name,
                type: column.data_type,
                level: column.level,
                isCategory: column.is_category,
                disabled: column.disabled,
                isSorted: false,
              })
            }
          })
        })

        this.tableData.defaultColumns = this.tableData.columns;
        
        this.filterTableColumns();
        
        this.tableData.filteredColumns = this.tableData.columns.map(column => (column.id)).filter(columnId => columnId !== "executive" && columnId !== "labor_costs" && columnId !== "comments")
      },
      deep: true
    },
    "tableData.activeFilteredColumns": {
      handler() {
        if (!this.isLoadingData) {
          this.isLoadingData = true;
          console.log('watch', this.tableData.activeFilteredColumns)
          this.setTableColumnFilters();
          
          this.tableData.page = 1;
          this.getRecords().then(() => {
            this.isLoadingData = false;
          });
        }
      },
      deep: true,
    },
  },

  async created() {
    await this.getData();
  },

  mounted() {
    const layout = document.querySelector(".layout");
    layout.addEventListener("scroll", this.handleLayoutScroll);
  },

  beforeDestroy() {
    const layout = document.querySelector(".layout");
    layout.removeEventListener("scroll", this.handleLayoutScroll);
  },

  methods: {
    removeCalculationSheet(calculationSheet) {
      this.$refs.removeCalculationSheet.open(calculationSheet);
    },
    removeCalculationSheetSubmit() {
      this.getData();
    },
    changeGoogleFormSubmit() {
      this.googleFormIsSubmitted = true
    },
    applyFilters() {
      // Post
      let postColumnIndex = this.tableData.globalFilters.findIndex(column => column.id === "global_post");

      let postFilterOptions = {
        id: "global_post",
        searchType: this.filtersForm.postReverse ? "2" : "1",
        type: "list",
        value: this.filtersForm.post ? [...this.filtersForm.post] : ""
      }
      
      if (this.filtersForm.post && this.filtersForm.post.length) {
        if (this.tableData.globalFilters[postColumnIndex]) {
          this.$set(this.tableData.globalFilters[postColumnIndex], 'value', postFilterOptions.value)
          this.$set(this.tableData.globalFilters[postColumnIndex], 'searchType', postFilterOptions.searchType)
        } else {
          this.tableData.globalFilters.push(postFilterOptions);
        }
      } else {
        const columnIds = this.tableData.globalFilters.filter((column) => ["global_post"].find(columnId => columnId === column.id)).filter((column) => column.id);

        columnIds.forEach((column) => {
          this.onGlobalFilterRemove(column);
        });
      }

      // Filial
      let filialColumnIndex = this.tableData.globalFilters.findIndex(column => column.id === "global_filials");

      let filialFilterOptions = {
        id: "global_filials",
        searchType: this.filtersForm.filialReverse ? "2" : "1",
        type: "list",
        value: this.filtersForm.filial ? [...this.filtersForm.filial] : ""
      }
      
      if (this.filtersForm.filial && this.filtersForm.filial.length) {
        if (this.tableData.globalFilters[filialColumnIndex]) {
          this.$set(this.tableData.globalFilters[filialColumnIndex], 'value', filialFilterOptions.value)
          this.$set(this.tableData.globalFilters[filialColumnIndex], 'searchType', filialFilterOptions.searchType)
        } else {
          this.tableData.globalFilters.push(filialFilterOptions);
        }
      } else {
        const columnIds = this.tableData.globalFilters.filter((column) => ["global_filials"].find(columnId => columnId === column.id)).filter((column) => column.id);

        columnIds.forEach((column) => {
          this.onGlobalFilterRemove(column);
        });
      }

      // Status
      let statusColumnIndex = this.tableData.globalFilters.findIndex(column => column.id === "global_status");

      let statusFilterOptions = {
        id: "global_status",
        searchType: this.filtersForm.statusReverse ? "2" : "1",
        type: "list",
        value: this.filtersForm.status ? [...this.filtersForm.status] : ""
      }
      
      if (this.filtersForm.status && this.filtersForm.status.length) {
        if (this.tableData.globalFilters[statusColumnIndex]) {
          this.$set(this.tableData.globalFilters[statusColumnIndex], 'value', statusFilterOptions.value)
          this.$set(this.tableData.globalFilters[statusColumnIndex], 'searchType', statusFilterOptions.searchType)
        } else {
          this.tableData.globalFilters.push(statusFilterOptions);
        }
      } else {
        const columnIds = this.tableData.globalFilters.filter((column) => ["global_status"].find(columnId => columnId === column.id)).filter((column) => column.id);

        columnIds.forEach((column) => {
          this.onGlobalFilterRemove(column);
        });
      }

      // Name
      let nameColumnIndex = this.tableData.globalFilters.findIndex(column => column.id === "global_name");

      let nameFilterOptions = {
        id: "global_name",
        searchType: "2",
        type: "string",
        value: this.filtersForm.name
      }
      
      if (this.filtersForm.name && this.filtersForm.name.length) {
        if (this.tableData.globalFilters[nameColumnIndex]) {
          this.$set(this.tableData.globalFilters[nameColumnIndex], 'value', nameFilterOptions.value)
          this.$set(this.tableData.globalFilters[nameColumnIndex], 'searchType', nameFilterOptions.searchType)
        } else {
          this.tableData.globalFilters.push(nameFilterOptions);
        }
      } else {
        const columnIds = this.tableData.globalFilters.filter((column) => ["global_name"].find(columnId => columnId === column.id)).filter((column) => column.id);

        columnIds.forEach((column) => {
          this.onGlobalFilterRemove(column);
        });
      }

      this.isLoadingData = true;
      this.setTableColumnFilters();
      this.getRecords().then(res => {
        this.isLoadingData = false;
        console.log('222')
      })
    },
    resetFilters() {
      // Post
      this.filtersForm.post = "";
      this.filtersForm.postReverse = "";

      // Filial
      this.filtersForm.filial = "";
      this.filtersForm.filialReverse = "";

      // Status
      this.filtersForm.status = "";
      this.filtersForm.statusReverse = "";

      // Name
      this.filtersForm.name = "";

      const columnIds = this.tableData.globalFilters.filter((column) => ["global_post", "global_filials", "global_status", "global_name"].find(columnId => columnId === column.id)).filter((column) => column.id);
      columnIds.forEach((column) => {
        this.onGlobalFilterRemove(column);
      });
      console.log('resetFilters')
      this.isLoadingData = true;
      this.setTableColumnFilters();
      this.getRecords().then(res => {
        this.isLoadingData = false;
      })
    },
    onGlobalFilterRemove(columnIndex) {
      let [deletedFilter] = this.tableData.globalFilters.splice(columnIndex, 1);
      const newQuery = {};
      if (deletedFilter && deletedFilter.id) {
        Object.entries(this.$route.query).forEach(([key, value]) => {
          let filterKey = deletedFilter.id;
          if (filterKey === "postCategorySpecialty") {
            filterKey = "posts";
          }
          if (!key.startsWith(`${filterKey}_column`)) {
            newQuery[key] = value;
          }
        });
        this.$router.replace({ name: "functions", query: newQuery }, () => {});
      }
    },
    resetColumnFilters() {
      const columnIds = this.tableData.activeFilteredColumns.filter((column) => column.id);
      columnIds.forEach((column) => {
        this.onColumnFilterRemove(column);
      });
      this.tableData.activeFilteredColumns = [];
    },
    openColumnSettingsModal() {

    },
    async getData() {
      this.isLoadingData = true;

      await this.getTableColumns();
      await this.getCollections();

      await this.updateFilters();
      await this.setFiltersFromQuery();
      await this.setQueryParams();

      // await this.getRecords();

      this.isLoadingData = false;
    },
    async getTableColumns() {
      await this.$store.dispatch("functions/getUserTableColumns");
      await this.$store.dispatch(`functions/getTableColumns`);
    },
    async getCollections() {
      await this.$store.dispatch(`calculationSheets/getFilials`);

      await this.$store.dispatch("functions/getStatusesList").then((res) => {
        this.collections.status = res.map(item => ({
          value: item.id,
          label: item.name,
          formatLabel: this.statusesIcons.find(icon => icon.id === item.id).value + ' ' + item.name,
          resultLabel: this.statusesIcons.find(icon => icon.id === item.id).value + ' ' + item.name,
        }))
      })

      await this.$store.dispatch("educationalMaterials/getPositions", {custom: true}).then((res) => {
        this.collections.post = [];

        Object.entries(res).forEach(([key, value]) => {
          let categories = [];
          let specialities = [];

          Object.entries(value.categories).forEach(([key2, value2]) => {
            categories.push({value: key2, label: value2})
          })

          Object.entries(value.specialties).forEach(([key3, value3]) => {
            specialities.push({value: key3, label: value3})
          })

          this.collections.post.push({
            value: key,
            label: value.name,
            sort: value.sort,
            collections: {
              categories: categories,
              specialities: specialities,
            }
          })

          this.collections.post = this.collections.post.sort((a, b) => b.sort - a.sort)
        });
      })
    },
    async getRecords() {
      this.sp = {
        sort: this.order,
        page: this.tableData.page,
        filters: this.tableData.filters,
        is_deleted: 0,
      };

      await this.$store.dispatch("functions/getFunctions", this.sp).then((res) => {
        if (res) {
          if (res && res.length > 0) {
            if (this.tableData.page === 1) {
              this.tableData.records = res.map((record) => new Function(record));
            } else {
              this.tableData.records = [...this.tableData.records, ...res.map((record) => new Function(record))];
            }
            this.isMoreDataAvailable = true;
          } else {
            this.tableData.records = [];
            this.isMoreDataAvailable = false;
          }
        }
      });
    },
    filterTableColumns() {
      this.tableData.columns = this.tableData.defaultColumns.filter((c) => this.userTableColumns.includes(c.id));
    },
    setTableColumnFilters() {
      const columnFilters = this.getTableColumnFilters();
      const globalFilters = this.getGlobalFilters();
      this.tableData.filters = { columnFilters, globalFilters, ...this.getCommonFilters() };
      this.setQueryParams({ ...this.tableData.filters });
    },
    getTableColumnFilters() {
      return this.tableData.activeFilteredColumns.reduce((acc, currentFilter) => {
        let columnFilter = {};
        let columnId = currentFilter.id;
        let filterValue = "";

        if (currentFilter.type === "list" && Array.isArray(currentFilter.value) && currentFilter.value.length) {
          filterValue = currentFilter.value.map((f) => f.value).join(",");
        } else {
          filterValue = currentFilter.value;
        }

        if (currentFilter.type === "date" && currentFilter.searchType === "range") {
          filterValue = currentFilter.value.split(',');
        }

        columnFilter = {
          [columnId]: {
            type: currentFilter.type,
            value: filterValue,
            searchType: currentFilter.searchType,
          },
        };

        return { ...acc, ...columnFilter };
      }, {});
    },
    getGlobalFilters() {
      return this.tableData.globalFilters.reduce((acc, currentFilter) => {
        let columnFilter = {};
        let columnId = currentFilter.id;
        let filterValue = "";

        if (currentFilter.type === "list" && Array.isArray(currentFilter.value) && currentFilter.value.length) {
          filterValue = currentFilter.value.map((f) => f.value).join(",");
        } else {
          filterValue = currentFilter.value;
        }

        if (currentFilter.type === "date" && currentFilter.searchType === "range") {
          filterValue = currentFilter.value.split(',');
        }

        columnFilter = {
          [columnId]: {
            type: currentFilter.type,
            value: filterValue,
            searchType: currentFilter.searchType,
          },
        };

        return { ...acc, ...columnFilter };
      }, {});
    },
    getCommonFilters() {
      return {
        sortingData: this.tableData.sortedColumn,
        page: this.tableData.page,
      };
    },
    setColumnReferenceFilterList(e) {
      this.tableData.referenceFilterList = this.collections[e.id];
    },
    onColumnFilterRemove(columnIndex) {
      const [deletedFilter] = this.tableData.activeFilteredColumns.splice(columnIndex, 1);
      const newQuery = {};
      Object.entries(this.$route.query).forEach(([key, value]) => {
        let filterKey = deletedFilter.id;
        if (!key.startsWith(`${filterKey}_column`)) {
          newQuery[key] = value;
        }
      });
      this.$router.replace({ name: "functions", query: newQuery });
      console.log('onColumnFilterRemove', columnIndex)
    },
    onSetColumnFilter(filterOptions) {
      this.tableData.activeFilteredColumns.push(filterOptions);
    },   
    onSetColumnFilterByIndex(columnIndex, filterOptions) {
      console.log(columnIndex)
      this.tableData.activeFilteredColumns[columnIndex] = filterOptions;
    },
    onDisableColumnSortedFlag(e) {
      console.log("onDisableColumnSortedFlag", e)
    },
    onSortingColumnChange(e) {
      this.tableData.page = 1;
      console.log("onSortingColumnChange", e)
    },
    resetColumnFilters() {
      const columnIds = this.tableData.activeFilteredColumns.filter((column) => column.id);
      columnIds.forEach((column) => {
        this.onColumnFilterRemove(column);
      });
      this.tableData.activeFilteredColumns = [];
    },
    openColumnSettingsModal() {
      this.$refs.columnSettings.open(this.userTableColumns);
    },
    onTableSort(column) {
      this.page = 1;
      this.tableData.sortedColumn.sortBy = column.sortBy;
      this.tableData.sortedColumn.sortType = column.sortType;

      console.log('column', column, this.tableData.sortedColumn);
      this.getData();
    },
    removeOperation(operation) {
      if (confirm("Расчетная ведомость будет удалена. Вы уверены?")) {
        this.$store
          .dispatch("calculationSheets/removeCalculationSheet", {
            id: operation.id
          })
          .then(res => {
            this.getData();
          });        
      }
    }, 
    removeTransaction(transaction) {
      this.$refs.removeTransaction.open(transaction);
    },
    restoreTransaction(transaction) {
      // this.$store.dispatch("personalEmployee/restoreTransactionAll", transaction.id.value).then((response) => {
      //   if (response.success) {
      //     this.applyFilters();
      //     this.$notify({
      //       group: "success-message",
      //       data: {
      //         textMessage: `Проводка на дату <b>${transaction.date.value}</b> успешно восстановлена`,
      //       },
      //     });
      //   }
      // });
    },
    handleLayoutScroll() {
      onScrollEnd(async () => {
        if (!this.isMoreDataAvailable || this.isLoadingData) {
          return;
        }

        if (this.tableData.page < this.totalPages) {
          this.tableData.page += 1;
          this.isLoadingData = true;
          await this.getRecords();
          setTimeout(() => {
            this.isLoadingData = false;
          }, 500);
        }
      });
    },
    editRecord(record) {
      this.$refs.typeModal.open(record);
    },
    async submitTableSettings(selectedColumns) {
      this.tableData.columns.filter((c) => selectedColumns.includes(c.id));

      this.isLoadingData = true;
      await this.$store.dispatch("functions/saveUserTableColumns", selectedColumns);

      this.filterTableColumns();
      this.isLoadingData = false;
    },
    setQueryParams(filters = {}) {
      const { query } = this.$route;
      let allQueries = { ...query, ...this.tableData.sortedColumn };
      console.log("setQueryParams", allQueries)

      if (filters.columnFilters) {
        const columnFilters = {};
        Object.entries(filters.columnFilters).forEach(([key, { value, searchType, type }]) => {
          if (type == "date" && searchType === "range") {
            columnFilters[`${key}_column`] = value.join(',');
          } else {
            columnFilters[`${key}_column`] = value;
          }
          
          columnFilters[`${key}_column_searchType`] = searchType;
          columnFilters[`${key}_column_filterType`] = type;
        });

        allQueries = { ...allQueries, ...columnFilters };
      }

      if (filters.globalFilters) {
        const globalFilters = {};
        Object.entries(filters.globalFilters).forEach(([key, { value, searchType, type }]) => {
          if (type == "date" && searchType === "range") {
            globalFilters[`${key}_column`] = value.join(',');
          } else {
            globalFilters[`${key}_column`] = value;
          }
          
          globalFilters[`${key}_column_searchType`] = searchType;
          globalFilters[`${key}_column_filterType`] = type;
        });

        allQueries = { ...allQueries, ...globalFilters };
      }

      console.log(query, allQueries)
      if (JSON.stringify(query) !== JSON.stringify(allQueries)) {
        this.$router.replace({ name: "functions", query: allQueries });
      }
    },
    updateFilters() {
      this.filters = { ...this.getCommonFilters(), columnFilters: this.getTableColumnFilters() };
    },
    async setFiltersFromQuery() {
      const { query } = this.$route;

      if ("sortBy" in query && this.isFirstInit) {
        this.tableData.sortedColumn.sortBy = query.sortBy;
      }
      if ("sortType" in query && this.isFirstInit) {
        this.tableData.sortedColumn.sortType = query.sortType;
      }

      this.isFirstInit = false

      const queryFilters = {};

      Object.entries(query).forEach(([key, value]) => {
        let filterKey = "";
        if (key.endsWith("_column")) {
          filterKey = key.replace("_column", "");
          queryFilters[filterKey] = { value };
          queryFilters[filterKey] = { ...queryFilters[filterKey], type: query[`${key}_filterType`] };
          queryFilters[filterKey] = { ...queryFilters[filterKey], searchType: query[`${key}_searchType`] };
        }
      });

      if (!queryFilters.length) {
        await this.getRecords().then(() => {
          this.isLoadingData = false;
        });
      }

      Object.entries(queryFilters).forEach(async ([key, value]) => {
        let filterId = key;

        const filter = {
          id: filterId,
          type: value.type,
          searchType: value.searchType,
        };
        
        if (filter.type === "list") {
          const selectedValues = value.value.split(",");
          filter.value = selectedValues;
          
          if (key.startsWith("global_")) {
            if (this.collections[filterId.replace("global_", "")]) {
              filter.value = this.collections[filterId.replace("global_", "")].filter((f) =>
                selectedValues.includes(f.value.toString()),
              );
            }
          } else {
            if (this.collections[filterId]) {
              filter.value = this.collections[filterId].filter((f) =>
                selectedValues.includes(f.value.toString()),
              );
            }
          }
        } else {
          filter.value = value.value;
        }

        if (filter.id === "global_period") {
          this.filtersForm.period = filter.value;
          this.$refs.period.period.setPeriodFlag = true;
          this.$refs.period.period.range = "custom";
          
          let array = filter.value.split(',');
          if (array.length === 1) {
            this.$refs.period.setDateInputTypeDate(filter.value);
            this.$refs.period.period.start.input = filter.value;
            this.$refs.period.period.end.input = filter.value;
          } else {
            this.$refs.period.setDateInputTypeDate(`${array[0]} - ${array[1]}`);
            this.$refs.period.period.start.input = String(array[0]);
            this.$refs.period.period.end.input = String(array[1]);
          }
        }

        if (filter.id === "global_post") {
          this.filtersForm.post = filter.value;
          this.filtersForm.postReverse = filter.searchType === "1" ? false : true
        }

        if (filter.id === "global_filials") {
          this.filtersForm.filial = filter.value;
          this.filtersForm.filialReverse = filter.searchType === "1" ? false : true
        }

        if (filter.id === "global_status") {
          this.filtersForm.status = filter.value;
          this.filtersForm.statusReverse = filter.searchType === "1" ? false : true
        }

        if (filter.id === "global_name") {
          this.filtersForm.name = filter.value;
        }

        if (key.startsWith("global_")) {
          this.tableData.globalFilters.push(filter);
        } else {
          this.tableData.activeFilteredColumns.push(filter);
        }

        this.applyFilters();
        // this.tableData.activeFilteredColumns.push({...filter});
      });
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.functions {
  &__add-new {
    @include vp-767 {
      width: 30px;
      height: 30px;

      /deep/ {
        .c-button__wrapper {
          width: 30px;
          height: 30px;
          padding: 0;
          justify-content: center;
        }
        .c-button__label {
          display: none;
        }
        .c-button__icon {
          margin: 0;
        }
      }
    }
  }
  &__filters {
    min-width: 100%;

    &-input {
      width: 100%;
    }

    &-actions {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      height: 100%;

      @include vp-1279 {
        justify-content: flex-end;
      }
    }

    &-action {
      &:not(:last-child) {
        margin-right: 10px;
      }

      @include vp-767 {
        width: calc((100% - 10px) / 2);
      }
    }
  }
  &__table {
    min-width: 100%;

    @include vp-767 {
      width: 100%;
      margin: 0;
    }

    &-actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 20px;
    }
    &-action {
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  .col {
    align-items: flex-end;
    margin-bottom: 25px;
  }

  /deep/ {
    .layout-header {
      @include vp-767 {
        flex-direction: row;
        height: auto;
        margin-bottom: 25px;
      }
    }
    .layout-header-actions {
      @include vp-767 {
        margin-top: 0;
      }
    }
    
    .subheader {
      flex-direction: column;
    }
    .sticky-column__last {
      width: 0;
    }
    .c-table__shadow {
      right: 57px;
    }
    .m-column-filters {
      padding: 0;
    }
  }
}
</style>
